import ResourceService from "./resource.service";

class ProductService extends ResourceService {
  static get resource() {
    return "product";
  }
}

export default ProductService;
